import { postFavoriteMarket } from './postFavoriteMarket';
import { removeFavoriteMarket } from './removeFavoriteMarket';

/**
 * - 최근본 상품의 찜관련 관련 api
 */
export const favoriteMarketService = {
  post: postFavoriteMarket,
  delete: removeFavoriteMarket,
};
